module.exports = __webpack_public_path__ + "img/rightarrow.de4c0d27.svg";